import React from 'react';
import { InfoOutline } from '@sparkpost/matchbox-icons';
import { Tooltip } from 'src/components/matchbox';
import styles from './InfoTooltip.module.scss';

function InfoTooltip({ content, size = 24, id = 'info-tooltip' }) {
  return (
    <Tooltip
      id={id}
      children={<InfoOutline className={styles.TooltipIcon} size={size} />}
      content={content}
      dark
      horizontalOffset="-0.15rem"
      right
    />
  );
}

export default InfoTooltip;
